import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getAllNamespaces} from 'src/openapi/admin/apis/EntitlementNamespacesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectEntitlementNamespaces} from './services/dictionary-slice';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

export const useEntitlementNamespaces = () => {
    const apiDispatch = useAppDispatch();
    const namespaces = useSelector(selectEntitlementNamespaces);

    const loadNamespaces = useCallback(() => {
        if (!namespaces.length) {
            apiDispatch(getAllNamespaces());
        }
    }, [namespaces?.length, apiDispatch]);

    const getNamespaceByCode = useCallback((code: string): DictionaryItem | undefined => {
        return namespaces?.find(e => e.code === code);
    }, [namespaces]);

    return {namespaces, loadNamespaces, getNamespaceByCode};
};
